module.exports = __webpack_public_path__ + "static/media/MD_TutorialSlides_10202020_09_Settings.7b919cdf.png";